import { Component, inject } from '@angular/core';

// Services
import { TranslationService } from '../../../core/services/translation/translation.service';
import { PwaService } from '../../../core/services/pwa/pwa.service';

@Component({
  selector: 'pwa-not-available',
  templateUrl: './pwa-not-available.component.html',
  styleUrls: ['./pwa-not-available.component.scss'],
  standalone: false,
})
export class PwaNotAvailableComponent {
  private readonly translate = inject(TranslationService);
  public readonly pwa = inject(PwaService);

  get incognitoModeLabel(): string {
    const modeName = this.pwa.modeName ?? 'PWA.PRIVATE_WINDOW';
    return this.translate.instant('PWA.NOT_ALLOW') + ' ' + this.translate.instant(modeName);
  }
}
